const category = [
  {
    display: "Men",
    categorySlug: "Men",
  },
  {
    display: "Women",
    categorySlug: "Women",
  },
];

export default category;
